import { setCookie } from '@elab/core/utils/cookie';
import { application } from '@elab/core/utils/appData';

export const setWishProductCookie = productCode => {
    setCookie(`${application.baseSiteId}-wishlist`, productCode, 1);
};
